import React from "react";

import { IMenuItemType, ISideMenuItem } from "../../types";
import { DraggableMenuItem } from "./DraggableSideMenuItem";
import { SideMenuItem } from "./SideMenuItem";

interface MainMenuItemProps {
  item: ISideMenuItem;
  index: number;
  dragEnabled?: boolean;
  dragTooltipCopy?: string;
  accentColor?: string;
  expandedItemId: string | null;
  setExpandedItemId: (id: string | null) => void;
  handleClose: () => void;
}
export const MainMenuItem: React.FC<MainMenuItemProps> = ({
  item,
  index,
  dragEnabled,
  dragTooltipCopy,
  handleClose,
  ...rest
}) => {
  const handleClick = () => {
    item?.onClick && item.onClick();
    handleClose();
  };

  return (
    <>
      {dragEnabled && item.type === IMenuItemType.draggable ? (
        <DraggableMenuItem
          {...item}
          index={index}
          dragEnabled={dragEnabled}
          dragTooltipCopy={dragTooltipCopy}
          onClick={handleClick}
          handleClose={handleClose}
          {...rest}
        />
      ) : (
        <SideMenuItem
          {...item}
          onClick={handleClick}
          handleClose={handleClose}
          {...rest}
        />
      )}
    </>
  );
};
